// ENTITY com.ic2.auth.mfa.TotpSetupDTO generated by ic2 4.0.0-SNAPSHOT at Thu Oct 01 15:16:30 UTC 2026

import { mapping, fields } from '@ic2/ic2-lib';

export class TotpSetupDTO {

  static readonly __ic2_fqn: string = 'com.ic2.auth.mfa.TotpSetupDTO';

  secret: string | null = '';
  otpauthUri: string | null = '';

  constructor(init?:Partial<TotpSetupDTO>) {
    Object.assign(this, init);
  }

  toString() {
    return JSON.stringify(this);
  }

}

mapping['com.ic2.auth.mfa.TotpSetupDTO'] = TotpSetupDTO;

fields['com.ic2.auth.mfa.TotpSetupDTO']  = {
    secret: 'java.lang.String',
    otpauthUri: 'java.lang.String'
};
